
import React from 'react';

interface CertificateProps {
  id: string;
  userName: string;
  skill: string;
  score: number;
}

const Certificate: React.FC<CertificateProps> = ({ id, userName, skill, score }) => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div 
      id={id}
      className="certificate-container relative w-[800px] h-[600px] bg-white border-8 border-double border-[#0EA5E9]/30 p-8"
    >
      <div className="certificate-inner border-2 border-[#0EA5E9]/20 p-8 h-full flex flex-col justify-between">
        <div className="certificate-header text-center">
          <h1 className="font-serif text-5xl text-[#0EA5E9] mb-2">Certificate of Achievement</h1>
          <p className="text-xl text-gray-600">Talento AI Platform</p>
        </div>
        
        <div className="certificate-body text-center mt-12 mb-12">
          <p className="text-xl text-gray-600 mb-4">This certifies that</p>
          <h2 className="font-serif text-3xl font-bold mb-6">{userName}</h2>
          <p className="text-xl text-gray-600 mb-4">has successfully completed</p>
          <h3 className="font-serif text-2xl font-bold text-[#0EA5E9] mb-6">{skill} Skill Assessment</h3>
          <p className="text-xl text-gray-600 mb-2">with a score of</p>
          <h3 className="font-serif text-3xl font-bold mb-6">{score}%</h3>
        </div>
        
        <div className="certificate-footer flex justify-between items-end">
          <div className="date text-left">
            <p className="text-gray-500">Date Issued</p>
            <p className="font-bold">{formattedDate}</p>
          </div>
          
          <div className="signature text-right">
            <div className="h-[60px] mb-2 flex items-end justify-end">
              <div className="w-[150px] h-[2px] bg-black"></div>
            </div>
            <p className="font-bold">Talento AI</p>
            <p className="text-gray-500">Certification Authority</p>
          </div>
        </div>
      </div>
      
      {/* Certificate Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5">
        <div className="rounded-full h-80 w-80 border-8 border-[#0EA5E9] flex items-center justify-center">
          <p className="text-6xl font-bold text-[#0EA5E9]">Talento AI</p>
        </div>
      </div>
    </div>
  );
};

export default Certificate;
